import { EntityType } from '@frontend/common';
import { EntityTypeSelect } from '@frontend/components/basic-forms';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import { EntityByTypeSelect } from '../entity-by-type-select/entity-by-type-select.component';

const ID = 'entity-select';
export interface EntitySelectProps {
    required?: boolean;
    submitted: boolean;
    onChange: (value: { entity_type?: EntityType; entity_id?: string }) => void;
    value?: { entity_type?: EntityType; entity_id?: string };
    dispatch: ThunkDispatch<any, any, AnyAction>;
}

export const EntitySelect = (props: EntitySelectProps) => {
    return (
        <div id={ID}>
            <EntityTypeSelect
                required={props.required}
                onSelect={(value) => {
                    props.onChange({
                        entity_type: (value?.value as EntityType | undefined) ?? undefined,
                        entity_id: undefined
                    });
                }}
                value={props.value?.entity_type}
            />
            {props.value?.entity_type && (
                <EntityByTypeSelect
                    required={props.required}
                    submitted={props.submitted}
                    type={props.value.entity_type.toString()}
                    value={props.value.entity_id}
                    onChange={(value) => {
                        props.onChange({
                            entity_type: props.value!.entity_type,
                            entity_id: value
                        });
                    }}
                    dispatch={props.dispatch}
                />
            )}
        </div>
    );
};
